import { z } from 'zod';
import { ApiSuccessResponseSchema } from './api';

/**
 * Email Operation Schemas
 * 
 * Epic 2 - Story 2.3: Runtime Type Safety
 * 
 * These schemas validate email-related operations.
 */

/**
 * Email To User Response
 */
export const EmailToUserResponseSchema = ApiSuccessResponseSchema(
  z.object({
    message: z.string(),
  })
);

export type EmailToUserResponse = z.infer<typeof EmailToUserResponseSchema>;

/**
 * Email To Manager Response
 */
export const EmailToManagerResponseSchema = ApiSuccessResponseSchema(
  z.object({
    message: z.string(),
  })
);

export type EmailToManagerResponse = z.infer<typeof EmailToManagerResponseSchema>;

/**
 * Remove External Email Response
 */
export const RemoveExternalEmailResponseSchema = ApiSuccessResponseSchema(
  z.object({
    message: z.string().optional(),
  })
);

export type RemoveExternalEmailResponse = z.infer<typeof RemoveExternalEmailResponseSchema>;

